import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterContainerSectionLabel = function (props) {
    var label = props.label, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-container-v2-section-label", { ref: ref, label: label, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterContainerSectionLabel;
